<template>
  <ScrollArea fade class="tabs-scroll">
    <View gap="lg" align="center" role="tablist" class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        role="tab"
        :id="tab.id"
        :aria-selected="modelValue === tab.key"
        class="tab"
        @click="emit('update:modelValue', tab.key)"
      >
        <Text variant="h5" :color="modelValue === tab.key ? 'primary' : 'secondary'">{{ tab.label }}</Text>
        <span v-if="tab.dot" class="tab__dot" />
      </button>
    </View>
  </ScrollArea>
</template>

<script setup lang="ts">
import ScrollArea from './scroll-area.vue';
import Text from './text.vue';
import View from './view/view.vue';

export interface TabItem {
  key: string;
  label: string;
  // Renders a small accent dot after the label (e.g. "new" indicator on AI insights).
  dot?: boolean;
  // DOM id of the tab button, for callers that need to address a tab (e.g. the product tour).
  id?: string;
}

defineProps<{ modelValue: string; tabs: TabItem[] }>();
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
</script>

<style scoped lang="scss">
// One line however many tabs there are: the row scrolls, and the scroll area's fade says so
.tabs-scroll {
  min-width: 0;
  max-width: 100%;
}

.tabs {
  width: max-content;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: var(--t-spacing-xs);
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
}

.tab__dot {
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background-color: var(--t-color-orange-500);
  flex-shrink: 0;
}
</style>
